import { render, staticRenderFns } from "./orderDetailTable.vue?vue&type=template&id=073c8c06&scoped=true&"
import script from "./orderDetailTable.vue?vue&type=script&lang=js&"
export * from "./orderDetailTable.vue?vue&type=script&lang=js&"
import style0 from "./orderDetailTable.vue?vue&type=style&index=0&id=073c8c06&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "073c8c06",
  null
  
)

export default component.exports